import { usePosContext } from "../context/pos-context";
import { useTranslation } from "react-i18next";
import { formatShortDate } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Package, ExternalLink } from "lucide-react";
import { routes } from "@/routes/route-constants";

export function PosOrderHistory() {
  const { t } = useTranslation("pos");
  const { orderHistory } = usePosContext();

  if (orderHistory.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="rounded-full bg-gray-100 p-4 mb-3">
          <Package className="h-10 w-10 text-gray-400" />
        </div>
        <p className="text-muted-foreground font-medium text-sm">
          {t("noOrderHistory")}
        </p>
      </div>
    );
  }

  return (
    <ul className="space-y-2">
      {orderHistory.map((order) => (
        <li
          key={order.id}
          className="flex items-center justify-between gap-2 py-2 px-3 rounded-lg bg-gray-50 border border-gray-100"
        >
          <div className="flex-1 min-w-0">
            <p className="font-medium text-sm text-foreground truncate">
              {order.orderNumber}
            </p>
            <p className="text-xs text-muted-foreground">
              {formatShortDate(order.date)}
            </p>
          </div>
          <span className="font-semibold text-primary text-sm flex-shrink-0">
            ${order.totalAmount.toFixed(2)}
          </span>
          <Button
            variant="outline"
            size="sm"
            className="flex-shrink-0 h-8 px-2"
            onClick={() =>
              window.open(routes.miniApp.order(order.id), "_blank")
            }
          >
            <ExternalLink className="h-3.5 w-3.5 mr-1" />
            {t("view")}
          </Button>
        </li>
      ))}
    </ul>
  );
}
